import * as type from "../types";

const initialState = {
  activePage: "overview",
  activeChild: null,
};

export const activePage = (state = initialState, payload) => {
  switch (payload.type) {
    case type.SET_ACTIVE_NAV_PAGE:
      return {
        ...state,
        activePage: payload.index,
      };
    case type.SET_ACTIVE_CHILD_NAV_PAGE:
      return {
        ...state,
        activeChild: payload.index,
      };
    default:
      return state;
  }
};
